// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sEUrB","field":"styles_field__3_YSD","fieldCol":"styles_fieldCol__1I3D3","diffCol":"styles_diffCol__2J8Ga","diff":"styles_diff__2w0xj"};